import { render, staticRenderFns } from "./TakingArtistDropdown.vue?vue&type=template&id=346a096b"
import script from "./TakingArtistDropdown.vue?vue&type=script&lang=js"
export * from "./TakingArtistDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports